import React, { useState, useEffect } from "react";
import { Loader } from "@vds/loaders";
import { connect } from "react-redux";
import AddContact from "./addContact/AddContact";
import * as account from "../api/account/index";
import * as StyledGlobalCSS from "../constants/common/StyledGlobalConstants";
import * as StyledTableCSS from "../constants/common/StyledTableConstants";
import * as StyledPaginationCSS from "../constants/common/StyledPaginationConstants";
import { CustomisedTertiaryButton, TextWrapperSpan, CPButton } from "../constants/common/StyledGlobalConstants";
import { Icon } from "@vds/icons";
import CPNotification from "../pages/Login/CPNotification";
import ManageInvoiceMobileView from "./ManageInvoiceMobileView";
import { Toggle } from "@vds/toggles";
import "./manageInvoice.css";
import { encryptor, firstNameLastName } from "../util/util";
import  SupportingUrl from "../constants/SupportingUrl";
import {
  ContactWrapper,
  MediumTextTableHeader,
  CustomTooltip,
  CPFontStyle,
  TextWrapper,
  AddContactContainer,
  AddContactText,
  LearnSpan,
  AddContactButton,
  CustomCancelButton,
  SortIconStyleOneInvoice,
  SortIconStyleInvoice,
  CustomToggleWrapper,
} from "./ManagePrimaryContactInvoice.styles";
import Pagination from "react-js-pagination";
import NoContactNotification from "./NoContactNotification";
import AscendingSortIcon from "../assets/icons/sort-ascending.png";
import DescendingSortIcon from "../assets/icons/sort-descending.png";
import NoSort from "../assets/icons/no-sort.png";
import { useTranslation } from "react-i18next";
import DeleteIcon from "../assets/icons/delete-icon-mip.png";
import DeleteIconDisabled from "../assets/icons/delete-icon-disabled-mip.png";
import RedesignedModal from "./common/RedesignedModal";
import { DEVICE_BREAKPOINTS } from "../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET, DESKTOP } = DEVICE_BREAKPOINTS;
function ManagePrimaryContactInvoice(props) {
  const [loader, setLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isReceiveInvoiceUpdate, setIsReceiveInvoiceUpdate] = useState({
    isOpen: false,
    toggleData: {},
  });
  const [isToggleDisabled, setIsToggleDisabled] = useState(false);
  const [isAnyContactPending, setIsAnyContactPending] = useState(false);
  const [fetchInvoiceUUID, setFetchInvoiceUUID] = useState(null);
  const [isNoContactNotification, setIsNoContactNotification] = useState(false);
  const [notificationBanner, setNotificationBanner] = useState({
    show: false,
    type: "",
    title: "",
  });

  const refreshContactTable = (tabledata, actiontype) => {
    const updatedTableData = tableData.map((data) => ({
      emailId: data.emailId,
      receiveInvoices: determineReceiveInvoices(data, tabledata, actiontype),
      status: determineStatus(data, tabledata, actiontype),
      contactId: data.contactId,
      contactFirstName: data.contactFirstName,
      contactLastName: data.contactLastName,
      contactStatus: data.contactStatus,
      isReceiveInvoiceNO: shouldRemoveInvoice(data, tabledata),
    }));

    const filteredTableData = actiontype === "deleteContact" ? filterDeletedContacts(updatedTableData) : updatedTableData;

    setTableData(filteredTableData);
    setActivePage(1);
  };

  // Helper function to determine the `receiveInvoices` value
  const determineReceiveInvoices = (data, tabledata, actiontype) => {
    if (tabledata.contactId === data.contactId && actiontype === "editContact" && tabledata.emailId === data.emailId) {
      return !tabledata.receiveInvoices;
    }
    if (tabledata.contactId === data.contactId && actiontype === "deleteContact" && tabledata.receiveInvoices === true) {
      return false;
    }
    return data.receiveInvoices;
  };

  // Helper function to determine the `status` value
  const determineStatus = (data, tabledata, actiontype) => {
    if (tabledata.contactId === data.contactId && tabledata.emailId === data.emailId) {
      if (actiontype === "editContact" && tabledata.contactId !== null) {
        return "Edit recipient pending";
      }
      if (data.status === "Receiving invoices") {
        return "Delete recipient pending";
      }
      return data.status;
    }
    return data.status;
  };

  // Helper function to determine if the invoice should be removed
  const shouldRemoveInvoice = (data, tabledata) => {
    return tabledata.emailId === data.emailId && !data.receiveInvoices && data.status === "Not receiving invoices";
  };

  // Helper function to filter deleted contacts
  const filterDeletedContacts = (updatedTableData) => {
    return updatedTableData.filter((data) => !data.isReceiveInvoiceNO);
  };

  const [isRemoveContact, setIsRemoveContact] = useState({
    modal: false,
    contactData: {},
  });
  const [t] = useTranslation("manageInvoiceTranslation");

  const [addContactNotification, setAddContactNotification] = useState({
    show: false,
    type: "",
    title: "",
  });
  const [showDeleteIcon, setShowDeleteIcon] = useState(true);

  const handleLearnMore = (e) => {
    e.preventDefault();
    window.open(SupportingUrl.LearnMoreRecipientListUrl, '_blank', 'noopener'); 
  };
  const handleAction = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      handleLearnMore(e);
    }
  };
  useEffect(() => {
    if (props.contractAccountId && props.businessPartnerId && props.mipTab === 2) {
      setNotificationBanner({
        show: false,
        type: "",
        title: "",
      });
      refreshTableData();
    }
  }, [props.mipTab]);
  const [activePage, setActivePage] = useState(1);
  const [invoiceContacts, setInvoiceContacts] = useState([]);
  const [totalRecordsCount, setTotalRecordsCount] = useState();
  const [recordsPerPage] = useState(10);
  const [sortInvoiceStatus, setSortInvoiceStatus] = useState("ascending");
  const validFinancialStatuses = ["Active", "Reactivated"];
  useEffect(() => {
    if (tableData) {
      contactTableWatcher();
    }
  }, [tableData]);

  const refreshTableData = () => {
    let otherCAuuid = [
      ...new Set(
        props.contractAccountCallResponse.getContractAccountCallResponse.reduce((accumulator, record) => {
          //Filtering different UUID, other than current contractAccount's UUID(landing contractAccount)
          if (record.uuid && record.uuid !== props.contractAccountCallResponse.uuid && validFinancialStatuses.includes(record.financialStatus)) {
            accumulator.push(record.uuid);
          }
          return accumulator;
        }, [])
      ),
    ];
    let requestBody = {
      contractAccountId: props.contractAccountId,
      businessPartnerId: props.businessPartnerId,
      otherCAUuid: otherCAuuid,
    };
    setLoader(true);
    account
      .fetchInvoicePreference(requestBody)
      .then((response) => {
        setLoader(false);
        if (response.data.data.data.length) {
          setTableData(response.data.data.data);
          setFetchInvoiceUUID(response.data.data.uuid);
          setIsNoContactNotification(false);
        } else {
          setIsNoContactNotification(true);
        }
      })
      .catch((err) => {
        setLoader(false);
        setIsNoContactNotification(false);
      });
  };
  const invoicePreferenceHandler = (contact) => {
    setIsReceiveInvoiceUpdate((prevState) => ({
      ...prevState,
      isOpen: true,
      toggleData: contact,
    }));
  };

  const receiveInvoiceUpdate = (contactData) => {
    let postData = {};
    postData = {
      data: [
        {
          emailId: contactData.emailId,
          receiveInvoices: !contactData.receiveInvoices,
          contactId: contactData.contactId === null || contactData.contactId === "" ? "" : contactData.contactId,
          inActiveByPortal: false,
        },
      ],
      uuid: fetchInvoiceUUID,
      contractAccountID: props.contractAccountId,
    };
    resetReceiveInvoiceUpdateHandler();
    setLoader(true);
    account
      .updateInvoicePreference(postData)
      .then((response) => {
        setLoader(false);

        setNotificationBanner((prevState) => ({
          ...prevState,
          show: true,
          type: "success",
          title: t(
            "We’ve received your request. It will take 24 hours or less for the recipient to be edited. You cannot make changes during this time."
          ),
        }));
        refreshContactTable(contactData, "editContact");
      })
      .catch((error) => {
        let msg = "";
        if (error?.response?.data?.statusCode === "409 CONFLICT") {
          msg = "We are currently working on a change which will take up to 24 hours to complete. Please try again after this time.";
        } else {
          msg = "We couldn’t update the recipient settings. Please try again later.";
        }
        setNotificationBanner((prevState) => ({
          ...prevState,
          show: true,
          type: "error",
          title: t(msg),
        }));
        setLoader(false);
      });
  };

  const removeContact = async (contactData) => {
    let contactPayload = {};
    //Filter Unique UUID contracts accounts
    const uniqueUUIDContractAccounts = props.contractAccountCallResponse?.getContractAccountCallResponse?.filter(
      (item, index, self) => index === self.findIndex((t) => t.uuid === item.uuid) && validFinancialStatuses.includes(item.financialStatus)
    );
    //Pull Unique contractAccountId
    const multiCAId = [
      ...new Set(
        uniqueUUIDContractAccounts.reduce((accumulator, record) => {
          accumulator.push(record.contractAccountId);
          return accumulator;
        }, [])
      ),
    ];
    contactPayload = {
      data: [
        {
          emailId: contactData.emailId,
          receiveInvoices: contactData.receiveInvoices,
          contactId: contactData.contactId === null || contactData.contactId === "" ? "" : contactData.contactId,
          inActiveByPortal: true,
        },
      ],
      uuid: fetchInvoiceUUID,
      contractAccountID: props.contractAccountId,
      multiCAId: multiCAId?.length > 1 ? await encryptor(multiCAId.join(";")) : null,
    };
    closeContactModal();
    setLoader(true);
    account
      .updateInvoicePreference(contactPayload)
      .then((response) => {
        setLoader(false);

        setNotificationBanner((prevState) => ({
          ...prevState,
          show: true,
          type: "success",
          title: t(
            "We’ve received your request. It will take 24 hours or less for the recipient to be deleted. You cannot make changes during this time."
          ),
        }));

        refreshContactTable(contactData, "deleteContact");
      })
      .catch((error) => {
        setLoader(false);
        let msg = "";
        if (error?.response?.data?.statusCode === "409 CONFLICT") {
          msg = "We are currently working on a change which will take up to 24 hours to complete. Please try again after this time.";
        } else {
          msg = "We couldn’t remove the recipient. Please try again later.";
        }
        setNotificationBanner({
          show: true,
          type: "error",
          title: t(msg),
        });
      });
  };

  const removeContactHandler = (contact) => {
    setIsRemoveContact({
      modal: true,
      contactData: contact,
    });
  };

  const closeContactModal = () => {
    setIsRemoveContact({ ...isRemoveContact, modal: false, contactData: {} });
  };

  const resetReceiveInvoiceUpdateHandler = () => {
    setIsReceiveInvoiceUpdate((prevState) => ({
      ...prevState,
      isOpen: false,
      toggleData: {},
    }));
  };

  const contactTableWatcher = () => {
    let receiveInvoiceYesCount = 0;
    let pendingStatusCount = 0;
    pendingStatusCount = tableData.filter(
      (data) =>
        data.status === "Pending" ||
        data.status === "Edit recipient pending" ||
        data.status === "Add recipient pending" ||
        data.status === "Delete recipient pending"
    ).length;
    pendingStatusCount >= 1 || props.viewInvoicesPermission === "ReadOnly" ? setIsAnyContactPending(true) : setIsAnyContactPending(false);
    receiveInvoiceYesCount = tableData.filter((data) => data.receiveInvoices === true).length;
    receiveInvoiceYesCount <= 1 ? setIsToggleDisabled(true) : setIsToggleDisabled(false);
    tableData?.length === 1 && receiveInvoiceYesCount === 1 ? setShowDeleteIcon(false) : setShowDeleteIcon(true);
  };

  const getToggleSwitch = (e) => <span style={CPFontStyle}>{e ? t("Yes") : t("No")}</span>;

  const toogleSwitch = (contact) => {
    let isfirstNameLastName = firstNameLastName(contact) === "--";

    const toggleDisableFunc = () => {
      return isAnyContactPending || isfirstNameLastName || (contact.receiveInvoices && isToggleDisabled);
    };

    return (
      <CustomToggleWrapper isYes={contact.receiveInvoices} disabled={toggleDisableFunc()}>
        <Toggle
          value={contact.receiveInvoices}
          surface="light"
          role="switch"
          tabIndex="0"
          ariaLabel="update invoice preference"
          id="update-invoice-preference-toggle"
          disabled={toggleDisableFunc()}
          showText={true}
          textWeight="regular"
          textSize="small"
          textPosition="left"
          on={contact.receiveInvoices === true}
          onChange={() => invoicePreferenceHandler(contact)}
          statusText={(e) => getToggleSwitch(e)}
        />
      </CustomToggleWrapper>
    );
  };
  useEffect(() => {
    tableData?.length && handleLoadTableData(sortInvoiceStatus);
  }, [activePage, tableData, sortInvoiceStatus]);

  const handleLoadTableData = (sortOrder) => {
    const lastRecordIndex = activePage * recordsPerPage;
    const firstRecordIndex = lastRecordIndex - recordsPerPage;
    let slicedData = [],
      statusSortData = [];
    statusSortData = sortBasedOnStatus(tableData, sortOrder);
    slicedData = statusSortData.slice(firstRecordIndex, lastRecordIndex);
    setTotalRecordsCount(tableData.length);
    setInvoiceContacts(slicedData);
  };
  const sortBasedOnStatus = (data, isSort) => {
    let sortedData = data;
    let status =
      isSort === "descending"
        ? {
            "Add recipient pending": 5,
            "Edit recipient pending": 4,
            "Delete recipient pending": 3,
            "Receiving invoices": 2,
            "Not receiving invoices": 1,
          }
        : {
            "Add recipient pending": 1,
            "Edit recipient pending": 2,
            "Delete recipient pending": 3,
            "Receiving invoices": 4,
            "Not receiving invoices": 5,
          };
    //Sort Fullname in alphabetical order
    sortedData.sort(function (a, b) {
      let firstValue = firstNameLastName(a)?.toLowerCase().replace(/\s/g, "");
      let secondValue = firstNameLastName(b)?.toLowerCase().replace(/\s/g, "");
      if (firstValue === "--") {
        return 1;
      }
      if (secondValue === "--") {
        return -1;
      }
      if (firstValue < secondValue) {
        return -1;
      }
      if (firstValue > secondValue) {
        return 1;
      }
      return 0;
    });
    //Sort data based on status
    sortedData.sort((a, b) => status[a.status] - status[b.status]);
    return sortedData;
  };

  const tableSort = (status) => {
    let result = status === "descending" ? "ascending" : "descending";
    setSortInvoiceStatus(result);
  };

  const handlePageChange = (pageNumber) => {
    let number = Number.parseInt(pageNumber);
    setActivePage(number);
  };
  const getSortIcon = () => {
    if (sortInvoiceStatus === "ascending") {
      return <SortIconStyleOneInvoice alt="ascending-icon" src={AscendingSortIcon} aria-hidden="true" tabIndex="-1" />;
    } else if (sortInvoiceStatus === "descending") {
      return <SortIconStyleOneInvoice alt="descending-icon" src={DescendingSortIcon} aria-hidden="true" tabIndex="-1" />;
    } else {
      return <SortIconStyleInvoice alt="search-icon" src={NoSort} aria-hidden="true" tabIndex="-1" />;
    }
  };
  const getMarginTop = (windowWidth) => {
    return windowWidth < 361 ? "1.5rem" : "2rem";
  };
  const getReceiveInvoiceTitle = (receiveInvoices) => {
    return receiveInvoices ? t("Stop receiving invoices?") : t("Start receiving invoices?");
  };
  const getModalAriaLabel = (receiveInvoices) => {
    return receiveInvoices ? "Stop receiving invoices?" : "Start receiving invoices?";
  };
  const getReceiveInvoiceButtonId = (receiveInvoices) => {
    return receiveInvoices ? "receive-invoice-update-stop-button" : "receive-invoice-update-start-button";
  };
  const getAriaLabel = (receiveInvoices) => {
    return receiveInvoices ? "Stop" : "Start";
  };
  const getReceiveInvoiceButtonText = (receiveInvoices) => {
    return receiveInvoices ? t("STOP") : t("START");
  };
  const getReceiveInvoiceMessage = (receiveInvoices) => {
    return receiveInvoices ? t("this email address will no longer receive invoices.") : t("this email address will receive invoices.");
  };
  return (
      <ContactWrapper className="contact-wrapper">
        <Loader active={loader} fullscreen={true} />
        {notificationBanner.show && (
          <div style={{ marginBottom: "1.5rem", marginTop: getMarginTop(props.windowSize.width) }}>
            <CPNotification
              isOpen={notificationBanner.show}
              notificationType={notificationBanner.type}
              closeButton={true}
              onClose={() => setNotificationBanner({ show: false, type: "", title: "" })}
              width="auto"
              height="auto"
            >
              <StyledGlobalCSS.Wrapper>{notificationBanner.title}</StyledGlobalCSS.Wrapper>
            </CPNotification>
          </div>
        )}
        {addContactNotification.show && (
          <div style={{ marginBottom: "1.5rem", marginTop: getMarginTop(props.windowSize.width) }}>
            <CPNotification
              isOpen={addContactNotification.show}
              notificationType={addContactNotification.type}
              closeButton={true}
              onClose={() => setAddContactNotification({ show: false, type: "", title: "" })}
              width="auto"
              height="auto"
            >
              <StyledGlobalCSS.Wrapper>{addContactNotification.title}</StyledGlobalCSS.Wrapper>
            </CPNotification>
          </div>
        )}

        {isRemoveContact.modal && (
          <RedesignedModal
            opened={isRemoveContact.modal}
            onClickClose={closeContactModal}
            zIndex={"1001"}
            isScrollable={false}
            title={t("Delete recipient?")}
            ModalAriaLabel="Delete recipient modal"
            button={
              <>
                <CustomisedTertiaryButton
                  id={"remove-contact-cancel-button"}
                  ariaLabel="Cancel"
                  tabIndex="0"
                  size="large"
                  buttonWidth={props.windowSize.width < TABLET && "100%"}
                  marginTop={"0"}
                  onClick={closeContactModal}
                >
                  {t("CANCEL")}
                </CustomisedTertiaryButton>
                <CPButton
                  id={"remove-contact-yes-button"}
                  ariaLabel="Delete"
                  tab-index="0"
                  size="large"
                  secondary={false}
                  boxButton={true}
                  buttonHeight="40px"
                  buttonWidth={props.windowSize.width < TABLET && "100%"}
                  onClick={() => removeContact(isRemoveContact.contactData)}
                >
                  {t("DELETE")}
                </CPButton>
              </>
            }
          >
            <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" lineHeight="20px" marginBottom="15px" marginTop="0">
              {t(`Starting next billing cycle, this email address will no longer receive invoices.`)}
            </TextWrapper>

            <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="0" marginTop="10px" lineHeight="20px">
              {t("This change will be visible in")}
              <b>{t("My Account")}</b>
              {t("in 24 hours or less - until then no other changes can be made to your recipient list. Deleting a recipient won’t")}
              <a
                href="https://reveal-help.verizonconnect.com/hc/articles/360010706839"
                target="_blank"
                style={{
                  margin: "0 0 0 5px",
                  color: "inherit",
                }}
              >
                {t("remove access to your Reveal account.")}
              </a>
            </TextWrapper>
          </RedesignedModal>
        )}

        {isReceiveInvoiceUpdate.isOpen && (
          <RedesignedModal
            opened={isReceiveInvoiceUpdate.isOpen}
            onClickClose={resetReceiveInvoiceUpdateHandler}
            zIndex={"1001"}
            isScrollable={false}
            title={getReceiveInvoiceTitle(isReceiveInvoiceUpdate.toggleData.receiveInvoices)}
            ModalAriaLabel={getModalAriaLabel(isReceiveInvoiceUpdate.toggleData.receiveInvoices)}
            button={
              <>
                <CustomCancelButton
                  id={"receive-invoice-update-cancel-button"}
                  ariaLabel="Cancel"
                  tabIndex="0"
                  size="large"
                  buttonWidth={props.windowSize.width < TABLET && "100%"}
                  marginTop={"0"}
                  onClick={() => resetReceiveInvoiceUpdateHandler()}
                >
                  {t("CANCEL")}
                </CustomCancelButton>
                <CPButton
                  id={getReceiveInvoiceButtonId(isReceiveInvoiceUpdate.toggleData.receiveInvoices)}
                  ariaLabel={getAriaLabel(isReceiveInvoiceUpdate.toggleData.receiveInvoices)}
                  tabIndex="0"
                  size="large"
                  secondary={false}
                  boxButton={true}
                  buttonHeight="40px"
                  buttonWidth={props.windowSize.width < TABLET && "100%"}
                  onClick={() => {
                    receiveInvoiceUpdate(isReceiveInvoiceUpdate.toggleData);
                  }}
                >
                  {getReceiveInvoiceButtonText(isReceiveInvoiceUpdate.toggleData.receiveInvoices)}
                </CPButton>
              </>
            }
          >
            <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" lineHeight="20px" marginBottom="15px" marginTop="0">
              {t("Starting next billing cycle,")}
              {getReceiveInvoiceMessage(isReceiveInvoiceUpdate.toggleData.receiveInvoices)}
            </TextWrapper>

            <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="0" marginTop="10px" lineHeight="20px">
              {t("This change will be visible in")}
              <b>{t("My Account")}</b>
              {t("in 24 hours or less — until then no other changes can be made to your recipient list.")}
              {isReceiveInvoiceUpdate.toggleData.receiveInvoices === true ? (
                <>
                  {t("If this person has a Reveal account, this action won’t")}
                  <a
                    href="https://reveal-help.verizonconnect.com/hc/articles/360010706839"
                    target="_blank"
                    style={{
                      margin: "0 0 0 5px",
                      color: "inherit",
                    }}
                  >
                    {t("remove their access to Reveal.")}{" "}
                  </a>
                </>
              ) : (
                <>
                  {t("Adding a recipient here won’t")}
                  <a
                    href="https://reveal-help.verizonconnect.com/hc/articles/360010706839"
                    target="_blank"
                    style={{
                      margin: "0 0 0 5px",
                      color: "inherit",
                    }}
                  >
                    {t("give access to your Reveal account.")}
                  </a>
                </>
              )}
            </TextWrapper>
          </RedesignedModal>
        )}
        {!isNoContactNotification ? (
          <>
              <AddContactContainer ismobile={props.windowSize.width < TABLET}>
                <AddContactText>
                  <p
                  /*Removed tabIndex from p tag as it was adding unnecessary tabclick */
                    style={{ outline: "none", margin: 0 }}
                    aria-label="Manage who receives invoices by email. You can make one change at a time. It takes up to 24 hours for a change to take effect, and
                    no other changes can be made during that time."
                  >
                    {t(
                      "Manage who receives invoices by email. You can make one change at a time. It takes up to 24 hours for a change to take effect, and no other changes can be made during that time."
                    )}
                    <LearnSpan>
                      <TextWrapperSpan
                        aria-label="learn more"
                        isLink
                        tabIndex="0"
                        color="#0077B4"
                        fontSize="0.875rem"
                        fontWeight="400"
                        lineHeight="1.25rem"
                        textDecorationLine="underline"
                        onClick={handleLearnMore}
                        style={{ cursor: "pointer" }}
                        onKeyDown={handleAction}
                      >
                        {t("Learn more")}
                      </TextWrapperSpan>
                    </LearnSpan>
                  </p>
                </AddContactText>
                <AddContactButton ismobile={props.windowSize.width < TABLET}>
                  <AddContact
                    refreshTableData={() => refreshTableData()}
                    isAnyContactPending={isAnyContactPending}
                    contractId={props.contractAccountId}
                    accountId={props.accountId}
                    tableData={tableData}
                    setTableData={setTableData}
                    addContactNotification={() =>
                      setNotificationBanner((prevState) => ({
                        ...prevState,
                        show: true,
                        type: "success",
                        title: t(
                          "We’ve received your request. It will take 24 hours or less for the new recipient to be added. You cannot make changes during this time."
                        ),
                      }))
                    }
                  />
                </AddContactButton>
              </AddContactContainer>
            <>
              {props.windowSize.width >= DESKTOP ? (
                <div aria-label="Invoice Contacts Table">
                  <StyledTableCSS.ContactTableWrapper aria-label="Invoice Contacts">
                    <thead>
                      <StyledTableCSS.ContactTableHeaderContainer aria-label="Table Header">
                        <MediumTextTableHeader
                          className="tableHeaderStyle"
                          style={{
                            width: "25%",
                          }}
                        >
                          {t("Full Name")}
                        </MediumTextTableHeader>
                        <MediumTextTableHeader
                          className="tableHeaderStyle"
                          style={{
                            width: "30%",
                          }}
                        >
                          {t("Email Address")}
                        </MediumTextTableHeader>
                        <MediumTextTableHeader
                          className="tableHeaderStyle"
                          style={{
                            width: "25%",
                          }}
                        >
                          {t("Receive Invoices")}
                        </MediumTextTableHeader>
                        <MediumTextTableHeader
                          className="tableHeaderStyle"
                          style={{
                            width: "15%",
                          }}
                          aria-sort={sortInvoiceStatus === "noSort" ? "other" : `${sortInvoiceStatus}`}
                          aria-label="Status"
                        >
                          <button id="status" className="sortableCol" tabIndex="0" onClick={() => tableSort(sortInvoiceStatus)}>
                            {t("Status")}
                            {getSortIcon()}
                          </button>
                        </MediumTextTableHeader>
                        <MediumTextTableHeader
                          className="tableHeaderStyle"
                          style={{
                            width: "10%",
                          }}
                        >
                          {t("Action")}
                        </MediumTextTableHeader>
                      </StyledTableCSS.ContactTableHeaderContainer>
                    </thead>

                    <tbody>
                      {invoiceContacts.length !== 0 ? (
                        invoiceContacts.map((contact, index) => {
                          let tooltipContent;

                          if (contact.receiveInvoices === true && isToggleDisabled === true) {
                            tooltipContent = (
                              <CustomTooltip
                                renderAnchorElement={() => (
                                  <StyledGlobalCSS.MediumText>
                                    <div>{toogleSwitch(contact)}</div>
                                  </StyledGlobalCSS.MediumText>
                                )}
                              >
                                {t(
                                  "To set this to No, you must first set another email address to Yes. There must always be at least one email address set to receive invoices."
                                )}
                              </CustomTooltip>
                            );
                          } else if (firstNameLastName(contact) === "--") {
                            tooltipContent = (
                              <CustomTooltip
                                renderAnchorElement={() => (
                                  <StyledGlobalCSS.MediumText>
                                    <div>{toogleSwitch(contact)}</div>
                                  </StyledGlobalCSS.MediumText>
                                )}
                              >
                                {t(
                                  "You can’t use this recipient because there is no full name. Please create a new recipient with all the relevant details and delete this one."
                                )}
                              </CustomTooltip>
                            );
                          } else {
                            tooltipContent = <>{toogleSwitch(contact)}</>;
                          }
                          let keyIndex = index;

                          return (
                            <StyledTableCSS.ContactTableBodyContainer key={keyIndex}>
                              <td
                                style={{
                                  width: "25%",
                                  wordBreak: "break-all",
                                }}
                              >
                                <StyledGlobalCSS.MediumText>
                                  <span style={CPFontStyle} className="Invoice_Ellipsis">
                                    {firstNameLastName(contact)}
                                  </span>
                                </StyledGlobalCSS.MediumText>
                              </td>
                              <td
                                style={{
                                  width: "30%",
                                  wordBreak: "break-all",
                                }}
                              >
                                <StyledGlobalCSS.MediumText>
                                  <span style={CPFontStyle} className="Invoice_Ellipsis">
                                    {contact.emailId}
                                  </span>
                                </StyledGlobalCSS.MediumText>
                              </td>
                              <td
                                style={{
                                  width: "25%",
                                }}
                              >
                                <StyledGlobalCSS.MediumText>{tooltipContent}</StyledGlobalCSS.MediumText>
                              </td>
                              <td
                                style={{
                                  width: "15%",
                                }}
                              >
                                <StyledGlobalCSS.MediumText>
                                  <span style={CPFontStyle}>{t(contact.status)}</span>
                                </StyledGlobalCSS.MediumText>
                              </td>
                              <td
                                style={{
                                  width: "10%",
                                }}
                              >
                                {showDeleteIcon && (
                                  <StyledGlobalCSS.MediumText style={{ textAlign: "center" }}>
                                    <StyledGlobalCSS.IconWrapper
                                      tabIndex={0}
                                      isFocusable={true}
                                      style={{
                                        padding: "0px",
                                        margin: "0px",
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => removeContactHandler(contact)}
                                      disabled={(contact.receiveInvoices === true && isToggleDisabled === true) || isAnyContactPending}
                                      id="invoice-preference-delete"
                                      aria-label="Delete button"
                                    >
                                      <img
                                        alt="delete_button"
                                        style={{
                                          width: "1rem",
                                          height: "1rem",
                                          cursor: "pointer",
                                          zIndex: 2,
                                        }}
                                        src={
                                          (contact.receiveInvoices === true && isToggleDisabled === true) || isAnyContactPending
                                            ? DeleteIconDisabled
                                            : DeleteIcon
                                        }
                                      />
                                    </StyledGlobalCSS.IconWrapper>
                                  </StyledGlobalCSS.MediumText>
                                )}
                              </td>
                            </StyledTableCSS.ContactTableBodyContainer>
                          );
                        })
                      ) : (
                        <StyledTableCSS.ContactTableBodyContainer style={{ display: "block" }}>
                          <td style={{ all: "unset" }}>
                            <h4 style={{ textAlign: "center" }}>{t("No Records to display")}</h4>
                          </td>
                        </StyledTableCSS.ContactTableBodyContainer>
                      )}
                    </tbody>
                  </StyledTableCSS.ContactTableWrapper>
                </div>
              ) : (
                <ManageInvoiceMobileView
                  invoice={invoiceContacts}
                  toogleSwitch={toogleSwitch}
                  isToggleDisabled={isToggleDisabled}
                  removeContactHandler={removeContactHandler}
                  isAnyContactPending={isAnyContactPending}
                  showDeleteIcon={showDeleteIcon}
                />
              )}
              {invoiceContacts?.length > 0 && (
                <StyledPaginationCSS.BillingBottom className="pagination" aria-label="pagination">
                  <StyledPaginationCSS.RightDiv>
                    <Icon
                      id="invoice-contacts-pagination-left-arrow"
                      name="left-arrow"
                      size="small"
                      color="#000000"
                      style={{ fontWeight: "bold" }}
                      backgroundColor="transparent"
                      aria-hidden="true"
                      tabIndex="-1"
                    />
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={recordsPerPage}
                      totalItemsCount={totalRecordsCount}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                      prevPageText={t("Previous")}
                      nextPageText={t("Next")}
                      hideFirstLastPages="true"
                      itemClassPrev="firstPage"
                      itemClassNext="nextPage"
                    />
                    <Icon
                      id="invoice-contacts-pagination-right-arrow"
                      name="right-arrow"
                      size="small"
                      color="#000000"
                      style={{ fontWeight: "bold" }}
                      backgroundColor="transparent"
                      aria-hidden="true"
                      tabIndex="-1"
                    />
                  </StyledPaginationCSS.RightDiv>
                </StyledPaginationCSS.BillingBottom>
              )}
            </>
          </>
        ) : (
          <NoContactNotification
            refreshTableData={() => refreshTableData()}
            isAnyContactPending={isAnyContactPending}
            contractId={props.contractAccountId}
            accountId={props.accountId}
            setNotificationBanner={setNotificationBanner}
          />
        )}
      </ContactWrapper>
  );
}

const mapStateToProps = (state) => {
  return {
    accountId: state.ACCOUNT.account_id,
    regionId: state.ACCOUNT.regionId,
    accountNumber: state.ACCOUNT.accountNumber,
    windowSize: state.ACCOUNT.windowSize,
    contractAccountId: state.BILLING.contractId,
    businessPartnerId: state.ACCOUNT.businessPartnerNumber,
    viewInvoicesPermission: state.ACCOUNT.viewInvoicesPermission,
    contractAccountCallResponse: state.BILLING.contractAccountCallResponse,
  };
};
ManagePrimaryContactInvoice.propTypes = {
  contractAccountId: PropTypes.string,
  businessPartnerId: PropTypes.string,
  mipTab: PropTypes.number,
  contractAccountCallResponse: PropTypes.object,
  windowSize: PropTypes.object,
  accountId: PropTypes.string,
  viewInvoicesPermission: PropTypes.string,
};

export default connect(mapStateToProps, null)(ManagePrimaryContactInvoice);